import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { PoliticalSpendingReportColumns, IEReportItemsColumns, IEReportColumns, IEPacReportColumns, BallotQuestionSpendingReportColumns, ElectioneeringCommunicationReportColumns } from '../../../types/referenceData/reportTableColumns';
import IePacReport from '../../../types/reports/iePacReport';
import IndependentExpenditureItem from '../../../types/reports/independentExpenditureItem';
import MiscReportContent from '../../../types/reports/miscReportContent';

interface Props {
    tableRows?: IndependentExpenditureItem[] | IePacReport[] | MiscReportContent[];
    type: string;
}

// keep these outside the component so their references stay stable across renders;
// the DataGrid recalculates row heights whenever getRowHeight changes
const getRowHeight = (): 'auto' => 'auto';
const columnVisibilityModel = { filed: false };

const IndependentSpendingReportsTable = (props: Props): JSX.Element => {
    let col;
    switch (props.type) {
        case 'ieItems': {
            col = IEReportItemsColumns;
            break;
        }
        case 'iePac': {
            col = IEPacReportColumns;
            break;
        }
         case 'bqSpending': { 
            col = BallotQuestionSpendingReportColumns;
            break; 
         } 
         case 'ecReports': {
          col = ElectioneeringCommunicationReportColumns;
          break;
         }
         case 'psr': {
          col = PoliticalSpendingReportColumns;
          break;
         }
         default: {  // default to ieReports
            col = IEReportColumns;
            break; 
         } 

    }
    return (
        <Box
        sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        '.MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold !important',
            // let long headers wrap instead of being clipped with an ellipsis
            whiteSpace: 'normal',
            lineHeight: 1.3,
            textOverflow: 'clip',
        },
        }}>
        <DataGrid
            rows={props.tableRows}
            columnVisibilityModel={columnVisibilityModel}
            getRowHeight={getRowHeight}
            // grow with the rows and let the page scroll; an inner vertical scrollbar takes
            // 15px from the columns, and when the screen is only just wide enough for them
            // it toggles a horizontal scrollbar on and off in an endless loop
            autoHeight
            columnHeaderHeight={58}
            columns={col}
            getRowId={(row) => row.id}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            sx={{
              '.MuiDataGrid-cell': {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                paddingTop: '3px!important',
                paddingBottom: '3px!important',
                display: 'flex',
                alignItems: 'center',
              },
              // the cell is a flex container, so its content needs min-width: 0
              // to be allowed to shrink and wrap instead of overflowing
              '.MuiDataGrid-cell > *': {
                minWidth: 0,
                maxWidth: '100%',
              },
            }}
        />
      </Box>
    );
}

export default IndependentSpendingReportsTable;